import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProtectedPage } from '~/src/components/templates'
import { AddUserForm } from '~/src/components/pages/AddUser/components/AddUserForm'
import { adminRepository } from '~/src/repositories'

export const AddUser: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleSubmit = async (id: number) => {
    try {
      setIsLoading(true)
      const { data } = await adminRepository.getAdmin()
      await adminRepository.post({
        id: id,
        loginId: data.admins[0].loginId,
        name: data.admins[0].name,
      })
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <ProtectedPage pageTitle={t('user.add_user')}>
      <AddUserForm onSubmit={(id) => handleSubmit(id)} isLoading={isLoading} />
    </ProtectedPage>
  )
}
